import { Node } from '@markdoc/markdoc';
import { isValidElement, ReactNode } from 'react';

import { RenderMarkdoc } from '@/src/components/markdoc/Markdoc';

export const resolveMarkdocTranslation = (
  textArray: readonly {
    readonly locale: string;
    readonly markdoc: { node: Node };
  }[],
  locale: string
): ReactNode => {
  const markdoc =
    textArray.find(item => item.locale === locale)?.markdoc.node || null;

  if (!markdoc) return null;
  return RenderMarkdoc({ node: markdoc });
};

export const resolveTranslation = (
  textArray: readonly {
    readonly locale: string;
    readonly text: string;
  }[],
  locale: string
): string | null => {
  if (!textArray) return null;
  return textArray.find(item => item.locale === locale)?.text || null;
};

export const extractTextFromReactNode = (
  node: Iterable<ReactNode> | ReactNode
) => {
  if (
    typeof node === 'string' ||
    typeof node === 'number' ||
    typeof node === 'bigint' ||
    typeof node === 'boolean'
  ) {
    return node.toString();
  }

  if (typeof node === 'object' && node !== null) {
    if (Array.isArray(node)) {
      return node.map(child => extractTextFromReactNode(child)).join(' ');
    }

    if (typeof node[Symbol.iterator] === 'function') {
      return Array.from(node as Iterable<ReactNode>)
        .map(child => extractTextFromReactNode(child))
        .join(' ');
    }

    if (isValidElement(node)) {
      return extractTextFromReactNode(node.props.children);
    }
  }

  return '';
};

export function extractTextFromMarkdoc(node) {
  if (node.children.length > 0) {
    return node.children.map(extractTextFromMarkdoc).join(' ');
  } else if (typeof node.attributes.content === 'string') {
    return node.attributes.content;
  }
  return '';
}

export const resolveMarkdocToSimpleTextTranslation = (
  textArray: readonly {
    readonly locale: string;
    readonly markdoc: { node: Node };
  }[],
  locale: string
): string => {
  const markdoc =
    textArray.find(item => item.locale === locale)?.markdoc || null;

  if (markdoc) {
    return extractTextFromMarkdoc(markdoc.node);
  }

  return '';
};
